import React, { useState, useEffect } from 'react'
import api           from '../../../services/api'
import Loader        from '../../Utils/Loader'
import AccountOverlay from './AccountOverlay'
import '../../../css/accountList.css'

const INITIAL_VISIBLE = 20

const AccountList = ({ refreshTrigger }) => {
  const [accounts, setAccounts] = useState([])
  const [roles,    setRoles]    = useState([])
  const [search,   setSearch]   = useState('')
  const [visible,  setVisible]  = useState(INITIAL_VISIBLE)
  const [flash,    setFlash]    = useState({ type: '', msg: '' })
  const [editing,  setEditing]  = useState(null)
  const [loading,  setLoading]  = useState(false)

  /* ───────────────── fetch iniziale ───────────────── */
  const loadData = async () => {
    setLoading(true)
    try {
      const [acc, role] = await Promise.all([api.get('/accounts'), api.get('/roles')])
      setAccounts(acc.data)
      setRoles(role.data)
    } catch (err) {
      console.error('Fetch account/ruoli fallita:', err)
      setFlash({ type: 'error', msg: 'Errore di rete' })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => { loadData() }, [refreshTrigger])

  /* ───────────────── filtraggio / paginazione ───────────────── */
  const filtered = accounts.filter(u =>
    u.email.toLowerCase().includes(search.toLowerCase()) ||
    (u.fullName || '').toLowerCase().includes(search.toLowerCase())
  )
  const toggleVisible = () =>
    setVisible(v => (v === filtered.length ? INITIAL_VISIBLE : filtered.length))

  /* ───────────────── delete ───────────────── */
  const handleDelete = async id => {
    if (!window.confirm('Eliminare questo account?')) return
    try {
      await api.delete(`/accounts/${id}`)
      setFlash({ type: 'success', msg: 'Account eliminato!' })
      loadData()
    } catch (err) {
      console.error('Errore eliminazione:', err)
      setFlash({ type: 'error', msg: 'Errore eliminazione' })
    }
  }

  /* ───────────────── render ───────────────── */
  return (
    <div className="account-list">

      {/* search bar centrale */}
      <div className="account-list-search">
        <input
          className="account-search"
          placeholder="Cerca account..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>
      
      {/* pulsante Aggiungi full-width */}
      <button className="add-account-btn" onClick={() => setEditing({})}>
        Aggiungi Account
      </button>

      

      {flash.msg && <p className={flash.type}>{flash.msg}</p>}

      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="account-list-items">
            {filtered.slice(0, visible).map(u => (
              <div key={u.id} className="account-card">
                <div className="account-info">
                  <h3>{u.fullName || '—'}</h3>
                  <p>{u.email}</p>

                  <div className="account-roles">
                    {u.roles.map(r => (
                      <span key={r.id} className="role-chip">{r.name}</span>
                    ))}
                  </div>
                </div>

                <div className="account-actions">
                  <button onClick={() => setEditing(u)}>Modifica</button>
                  <button onClick={() => handleDelete(u.id)}>Elimina</button>
                </div>
              </div>
            ))}
          </div>

          {filtered.length > INITIAL_VISIBLE && (
            <button className="load-more-btn" onClick={toggleVisible}>
              {visible === filtered.length ? 'Mostra meno' : 'Mostra altro'}
            </button>
          )}
        </>
      )}

      {editing !== null && (
        <AccountOverlay
          account={editing}
          roles={roles}
          onClose={() => { setEditing(null); loadData() }}
        />
      )}
    </div>
  )
}

export default AccountList
